export default [
    //客户管理-客户管理
    {
        path: "/customer",
        name: "customer",
        component: () => import("@/views/customerManagment/customer.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //客户管理-详情
    {
        path: "/customerDetail",
        name: "customerDetail",
        component: () => import("@/views/customerManagment/customerDetail.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    
]